import { getCookieByName } from './browser-util';

const { VUE_APP_TESTER, VUE_APP_GATEKEEPER_URL } = process.env;

const middlewarePipeline = (context, middleware, index) => {
  const nextMiddleware = middleware[index];

  if (!nextMiddleware) {
    return context.next;
  }

  return () => {
    const nextPipeline = middlewarePipeline(context, middleware, index + 1);

    nextMiddleware({ ...context, next: nextPipeline });
  };
};

const requiresAuth = ({
  to: { path },
  next,
  store: {
    state: {
      student: { successfullyLoggedIn },
      application: { kwtMode }
    }
  }
}) =>
  (kwtMode === 'preview' && path === '/spotcheck-result') || successfullyLoggedIn
    ? next()
    : next({ path: '/login' });

const detectActivityData = ({
  next,
  store: {
    state: {
      activity: {
        dataLoaded,
        data: { activityId }
      }
    }
  }
}) =>
  // no activityId
  activityId !== null && dataLoaded ? next() : next({ name: 'login' });

const testerAuth = async ({
  next,
  store: {
    state: {
      student: { successfullyLoggedIn }
    }
  }
}) => {
  if (VUE_APP_TESTER === 'true') {
    if (successfullyLoggedIn) return Promise.resolve(next());

    const sessionCookie = await getCookieByName('session');
    return Promise.resolve(sessionCookie ? next({ path: '/login' }) : next());
  }
  return Promise.resolve(next({ path: '/login' }));
};

// Provides backwards compatibility for already distributed home use emails, but it can be removed once that is no longer required.
const homeUseTokenRedirect = ({ next, to: { query } }) => {
  if (query.homeUseToken) {
    window.location.replace(
      `${VUE_APP_GATEKEEPER_URL}/auth/home-use/${query.homeUseToken}?app=keyboarding`
    );
    return;
  }

  return next();
};

export { detectActivityData, homeUseTokenRedirect, middlewarePipeline, requiresAuth, testerAuth };
